import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuthContext } from "../hooks/useAuthContext";
import {
  getAnalyticsConsent,
  initializeAnalytics,
  onAnalyticsConsentChange,
  trackPageView,
} from "../analytics";

const AnalyticsTracker = () => {
  const location = useLocation();
  const { user } = useAuthContext();
  const [consent, setConsent] = useState(getAnalyticsConsent());
  const userId = user?._id || user?.userID || null;

  useEffect(() => onAnalyticsConsentChange((event) => setConsent(event.detail)), []);

  useEffect(() => {
    if (consent !== "granted") return;
    initializeAnalytics(userId);
    trackPageView(`${location.pathname}${location.search}`, userId);
  }, [consent, location.pathname, location.search, userId]);

  return null;
};

export default AnalyticsTracker;
